module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc15-1b58b2f1d1b584121990b987f8b7a6e9.jpg";